import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { HomeMemberResult } from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { CookingStoryMembersService } from 'src/app/data/repository/cooking-story/cooking-story-members.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';

@Component({
  selector: 'app-cooking-story-member-invite-confirm',
  templateUrl: './cooking-story-member-invite-confirm.component.html',
  styleUrls: ['./cooking-story-member-invite-confirm.component.scss'],
})
export class CookingStoryMemberInviteConfirmComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: HomeMemberResult,
    private bottomSheetRef: MatBottomSheetRef<CookingStoryMemberInviteConfirmComponent>,
    private recipeService: RecipeService,
    private userDataService: UserDataService,
    private CookingStoryGroceryApiService: CookingStoryGroceryApiService,
    private CookingStoryMembersService: CookingStoryMembersService,
    private cookingStoryGroceryService: CookingStoryGroceryService
  ) {}

  ngOnInit(): void {}
  goBack() {
    this.bottomSheetRef.dismiss();
    this.recipeService.goToHomeMembers();
  }
  accept() {
    this.userDataService
      .getUser()
      .then((user) => {
        this.CookingStoryGroceryApiService.joinUserToHome(
          user._id,
          this.data._id
        );
        this.goBack();
        this.cookingStoryGroceryService.openPopUp.next('به خانه جدید عضو شدی.');
      })
      .then(() => {
        this.CookingStoryMembersService.updateUser.next();
      });
  }
}
